export default "__VITE_ASSET__CBPi21a$__"